export type UpdateCategory = 'Certification' | 'Recognition' | 'Award' | 'News';

export interface Update {
  /** Stable slug used as the React key. */
  id: string;
  /** Machine-readable date, e.g. "2026-10-08". */
  date: string;
  /** Human-readable date shown on the card. */
  displayDate: string;
  category: UpdateCategory;
  title: string;
  issuer: string;
  presenter?: string;
  description?: string;
  /** Thumbnail shown on the card (keep under ~100 KB). */
  image: string;
  /** Higher-resolution image opened in the lightbox. */
  fullImage: string;
  /** Optional original signed certificate. */
  pdf?: string;
  /** Optional external verification link. */
  href?: string;
}

/** Newest first. Add new entries at the top. */
export const updates: Update[] = [
  {
    id: 'icms-2026-girish-m',
    date: '2026-10-08',
    displayDate: 'October 4–8, 2026',
    category: 'Recognition',
    title: 'ICMS 2026 — Certificate of Participation',
    issuer: '7th International Conference on Molecular Simulation · IISc Bengaluru',
    presenter: 'Girish M',
    description:
      'Presented a talk/poster at the 7th International Conference on Molecular Simulation, held at the Indian Institute of Science, Bengaluru.',
    image: '/certificates/icms-2026-girish-m-thumb.jpg',
    fullImage: '/certificates/icms-2026-girish-m-full.jpg',
    pdf: '/certificates/icms-2026-girish-m.pdf',
  },
  {
    id: 'icms-2026-hemanth-shetty-mundaje',
    date: '2026-10-08',
    displayDate: 'October 4–8, 2026',
    category: 'Recognition',
    title: 'ICMS 2026 — Certificate of Participation',
    issuer: '7th International Conference on Molecular Simulation · IISc Bengaluru',
    presenter: 'Hemanth Shetty Mundaje',
    description:
      'Presented a talk/poster at the 7th International Conference on Molecular Simulation, held at the Indian Institute of Science, Bengaluru.',
    image: '/certificates/icms-2026-hemanth-shetty-mundaje-thumb.jpg',
    fullImage: '/certificates/icms-2026-hemanth-shetty-mundaje-full.jpg',
    pdf: '/certificates/icms-2026-hemanth-shetty-mundaje.pdf',
  },
];
